import { render, staticRenderFns } from "./SeasonalIngredientsView.vue?vue&type=template&id=3fbf990e&scoped=true"
import script from "./SeasonalIngredientsView.vue?vue&type=script&lang=js"
export * from "./SeasonalIngredientsView.vue?vue&type=script&lang=js"
import style0 from "./SeasonalIngredientsView.vue?vue&type=style&index=0&id=3fbf990e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbf990e",
  null
  
)

export default component.exports